import { harnessChipClass } from '../harnessColours';

/** The backend labels an engine "Runs via Claude Code"; the UI shows just the engine. */
const engineName = (label: string): string => label.replace(/^Runs via /, '');

/** A harness's engine (Claude Code, Codex CLI) as a chip coloured by its type. */
export function HarnessEngineChip({
  harnessType,
  label,
}: {
  harnessType: string;
  label: string;
}) {
  return (
    <span
      className={`w-fit max-w-full truncate rounded-full px-2 py-0.5 text-xs font-medium ${harnessChipClass(harnessType)}`}
    >
      {engineName(label || harnessType)}
    </span>
  );
}
